// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1-Nc8","right":"styles_right__3zkC_"};